import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "display" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    d: "M20.3333 3H3.66667C2.74653 3 2 3.74653 2 4.66667V15.7778C2 16.6979 2.74653 17.4444 3.66667 17.4444H10.3333L9.77778 19.1111H7.27778C6.81597 19.1111 6.44444 19.4826 6.44444 19.9444C6.44444 20.4063 6.81597 20.7778 7.27778 20.7778H16.7222C17.184 20.7778 17.5556 20.4063 17.5556 19.9444C17.5556 19.4826 17.184 19.1111 16.7222 19.1111H14.2222L13.6667 17.4444H20.3333C21.2535 17.4444 22 16.6979 22 15.7778V4.66667C22 3.74653 21.2535 3 20.3333 3ZM19.7778 15.2222H4.22222V5.22222H19.7778V15.2222Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }